module.exports = __webpack_public_path__ + "static/img/cont34 (2).a12a1c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont34 (2).jpg
// module id = gPOO
// module chunks = 0